import { CheckIcon, ScanLineIcon, SparklesIcon } from 'lucide-react';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import type { EstateProjectSearchItem } from '../types';

type FinishStepProps = {
  isUploading: boolean;
  selectedItem: EstateProjectSearchItem;
  onUpload: () => Promise<void>;
};

export const FinishStep: FC<FinishStepProps> = ({ isUploading, selectedItem, onUpload }) => {
  const { t } = useTranslation();

  return (
    <div className="min-h-0 flex-1 px-6 pb-4">
      <div className="flex h-full flex-col items-center justify-center gap-4 pb-4 text-center">
        <div className="flex size-20 items-center justify-center rounded-full bg-primary-lighter/40 text-primary-light">
          <CheckIcon className="size-9" />
        </div>
        <div>
          <h3 className="text-lg font-bold text-primary-dark">{t('uploadFloorPlan')}</h3>
          <p className="mt-2 text-base font-medium text-slate-500">
            {t('uploadingTo')}: {selectedItem.name}
          </p>
        </div>

        <div className="mt-4 w-full space-y-3">
          <button
            type="button"
            className="flex h-20 w-full items-center gap-4 rounded-md border border-slate-200 px-4 text-left transition-colors hover:border-primary-light hover:bg-slate-50 disabled:pointer-events-none disabled:opacity-60"
            disabled={isUploading}
            onClick={() => void onUpload()}
          >
            <span className="flex size-12 shrink-0 items-center justify-center rounded-md bg-primary-lighter/40 text-primary-light">
              <CheckIcon className="size-5" />
            </span>
            <span>
              <span className="block text-base font-bold text-primary-dark">{t('justUpload')}</span>
              <span className="block text-sm font-medium text-slate-500">
                {t('saveFloorPlanAndClose')}
              </span>
            </span>
          </button>

          <button
            type="button"
            className="flex h-20 w-full items-center gap-4 rounded-md border border-slate-200 px-4 text-left opacity-60"
            disabled
          >
            <span className="flex size-12 shrink-0 items-center justify-center rounded-md bg-primary-lighter/40 text-primary-light">
              <ScanLineIcon className="size-5" />
            </span>
            <span>
              <span className="block text-base font-bold text-primary-dark">
                {t('paper2Pixel')}
              </span>
              <span className="block text-sm font-medium text-slate-500">
                {t('convertFloorPlanToDigitalVersion')}
              </span>
            </span>
          </button>

          <button
            type="button"
            className="flex h-20 w-full items-center gap-4 rounded-md border border-slate-200 px-4 text-left opacity-60"
            disabled
          >
            <span className="flex size-12 shrink-0 items-center justify-center rounded-md bg-primary-lighter/40 text-primary-light">
              <SparklesIcon className="size-5" />
            </span>
            <span>
              <span className="block text-base font-bold text-primary-dark">
                {t('requestCreationFromRealitiq')}
              </span>
              <span className="block text-sm font-medium text-slate-500">
                {t('teamCreates3dFloorPlan')}
              </span>
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};
